import { BehaviorSubject } from 'rxjs';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    Component,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    HostBinding,
    OnInit,
    ElementRef,
    Renderer2,
    ViewChild,
    HostListener,
    OnDestroy,
} from '@angular/core';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';

@Component({
    selector: 'ccm-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-tag' },
    standalone: false,
})
export class TagComponent implements OnInit, OnDestroy {
    @Input() name: string;
    @Input() title: string;
    @Input() profileData;
    @Input() objectType;
    @Input() mediaBankPhysicalFileName: string;
    @Input() mediaBankExtension: string;
    @Input()
    @HostBinding('class.ReadOnly')
    isReadOnly: boolean = false;

    @Output('delete') onDelete = new EventEmitter();

    showMobileTooltip: boolean = false;

    @ViewChild('deleteElement', { static: false }) deleteElement: ElementRef;

    isUserAvatarShown$ = new BehaviorSubject<boolean>(false);
    ProfileSizes = FiProfileSizes;

    constructor(
        private renderer: Renderer2,
        private fiMediaStorageService: FiMediaStorageService,
    ) {}

    ngOnInit() {
        if (this.objectType === ObjectTypes.User) {
            this.isUserAvatarShown$.next(true);
            if (!this.profileData.hasOwnProperty('FullName') && this.profileData.hasOwnProperty('Name')) {
                this.profileData.FullName = this.profileData.Name;
            }
        }
    }

    deleteClick($event) {
        $event.stopPropagation();
        this.onDelete.emit();
    }

    private documentClickListener: any;

    @HostListener('click', ['$event'])
    elementClick($event) {
        if (
            this.isReadOnly ||
            this.deleteElement.nativeElement.contains($event.target) ||
            !this.title ||
            this.title === this.name ||
            !window.matchMedia('(max-width: 768px)').matches
        ) {
            return false;
        }

        if (!this.showMobileTooltip) {
            this.openTooltip();
        } else {
            this.closeTooltip();
        }
    }

    ngOnDestroy() {
        this.closeTooltip();
    }

    openTooltip() {
        this.showMobileTooltip = true;
        setTimeout(() => {
            this.documentClickListener = this.renderer.listen('document', 'click', (clickEvent) => {
                this.closeTooltip();
            });
        });
    }

    closeTooltip() {
        this.showMobileTooltip = false;
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }
}
